import { ReactNode } from 'react';
import useLanguageRegionCode from 'hooks/useLanguageRegionCode';
import SectionDivider from 'components/shared/SectionDivider';
import { facebookHandler, appleHandler, googleHandler } from 'utils/OAuthHandlers';
import { LanguageSupportUtil } from 'utils/language_support_util';
import { FormattedMessage } from '@alltrails/shared/react-intl';
import AltLoginsForm from 'components/AltLoginsForm';
import RegisterForm from 'components/RegisterForm';
import * as baseStyles from '../../../styles/baseStyles.module.scss';
import * as styles from './styles/styles.module.scss';

type Props = {
  handleRegistrationSuccess: any;
  userEmailSubscribed?: boolean;
  handleLoginClick: React.MouseEventHandler<HTMLAnchorElement>;
  redirectTo: string;
  referralLink: string;
};

const RegistrationForm: React.FC<Props> = ({ handleRegistrationSuccess, userEmailSubscribed, handleLoginClick, referralLink, redirectTo }) => {
  const locale = useLanguageRegionCode();

  function registrationSuccessCallback(data: any) {
    if (handleRegistrationSuccess) {
      handleRegistrationSuccess(data);
    }

    if (!redirectTo) {
      return;
    }

    window.location.href = redirectTo;
  }

  function handleGoogle(response: any) {
    googleHandler(
      response,
      locale,
      registrationSuccessCallback,
      () => {},
      () => null,
      referralLink
    );
  }

  function handleFacebook(response: any) {
    facebookHandler(
      response,
      locale,
      registrationSuccessCallback,
      () => {},
      () => null,
      referralLink
    );
  }

  function handleApple() {
    appleHandler(referralLink);
  }

  return (
    <div>
      <AltLoginsForm googleLoginHandler={handleGoogle} facebookLoginHandler={handleFacebook} appleLoginHandler={handleApple} />
      <SectionDivider classes={styles.sectionDivider}>
        <FormattedMessage defaultMessage="or" />
      </SectionDivider>
      <div className={baseStyles.section}>
        <RegisterForm referralLink={referralLink} handleRegistrationSuccess={registrationSuccessCallback} userEmailSubscribed={userEmailSubscribed} />
      </div>
      <div className={styles.alreadyHaveAnAccount}>
        <FormattedMessage defaultMessage="Already have an account?" />{' '}
        <a className={baseStyles.route} href={LanguageSupportUtil.wrapUrlSafe('/login', locale)} onClick={handleLoginClick}>
          <FormattedMessage defaultMessage="Log in" />
        </a>
      </div>
    </div>
  );
};

export default RegistrationForm;
